import {
  DEFAULT_SYSTEM_SETTING_TAB_VIEWS,
  DEFAULT_SYSTEM_SETTING_TAB_VIEWS_LOCATION,
  FORM_VIEW,
  LOCATIONS_FORM_VIEW,
  SYSTEM_SETTING_FORM_VIEW,
} from '@product-framework/pages/ServiceProvider/constants';
import { SCOPES, LOCATIONS_STEPPER_ID } from './constants';

const MODULE_TAB_PURCHASE_FLAGS = {
  [SYSTEM_SETTING_FORM_VIEW.CLAIMS]: 'claimsPurchased',
  [SYSTEM_SETTING_FORM_VIEW.DISPATCH]: 'dispatchPurchased',
  [SYSTEM_SETTING_FORM_VIEW.INSIGHT]: 'insightPurchased',
};

function isModuleTabPurchased(view, moduleSettings = {}) {
  const purchaseFlag = MODULE_TAB_PURCHASE_FLAGS[view];
  if (!purchaseFlag) {
    return true;
  }
  return moduleSettings[purchaseFlag] === true;
}

function deriveServiceProviderScope({ serviceProviderLocationId }) {
  const hasServiceProviderLocationId =
    serviceProviderLocationId != null && serviceProviderLocationId !== '';

  return {
    scope: hasServiceProviderLocationId
      ? SCOPES.LOCATION
      : SCOPES.SERVICE_PROVIDER,
    locationId: hasServiceProviderLocationId ? serviceProviderLocationId : null,
  };
}

function buildTabNavigationPath({
  serviceProviderId,
  mainTabIndex,
  locationId,
  globalIndex,
}) {
  const stepPathSegment = mainTabIndex + 1;
  if (locationId != null && locationId !== '') {
    return `/serviceproviders/edit/${serviceProviderId}/${stepPathSegment}/${FORM_VIEW.EDIT}/${locationId}/${LOCATIONS_FORM_VIEW.SYSTEM_SETTINGS}/${globalIndex}`;
  }
  return `/serviceproviders/edit/${serviceProviderId}/${stepPathSegment}/${globalIndex}`;
}

function resolveSystemSettingsTabViews(scope) {
  return scope === SCOPES.LOCATION
    ? DEFAULT_SYSTEM_SETTING_TAB_VIEWS_LOCATION
    : DEFAULT_SYSTEM_SETTING_TAB_VIEWS;
}

function hasVisibleLocationSystemSettingsTabs(moduleSettings = {}) {
  return resolveSystemSettingsTabViews(SCOPES.LOCATION).filter(view =>
    isModuleTabPurchased(view, moduleSettings),
  );
}

function getApiEndPoints(apiBaseUrl, serviceProviderId, locationId = null) {
  if (locationId != null && locationId !== '') {
    return {
      claimSettingsApiUrl: `${apiBaseUrl}/sxcl/v1/service-providers/${serviceProviderId}/locations/${locationId}/claim-settings`,
      rateCardApiUrl: `${apiBaseUrl}/sxcl/v1/service-providers/${serviceProviderId}/locations/${locationId}`,
      performanceApiUrl: `${apiBaseUrl}/sxcl/v1/service-providers/${serviceProviderId}/locations/${locationId}/performance`,
    };
  }
  return {
    claimSettingsApiUrl: `${apiBaseUrl}/sxcl/v1/service-provider-profile/${serviceProviderId}/claims`,
    dispatchSettingsApiUrl: `${apiBaseUrl}/sxcl/v1/service-provider-profile/${serviceProviderId}/dispatch`,
    insightSettingsApiUrl: `${apiBaseUrl}/sxcl/v1/service-provider-profile/${serviceProviderId}/insight`,
    apiKeysSettingsApiUrl: `${apiBaseUrl}/sxcl/v1/service-provider-profile/${serviceProviderId}/api-keys`,
    rateCardApiUrl: `${apiBaseUrl}/sxcl/v1/service-providers/${serviceProviderId}`,
    performanceApiUrl: `${apiBaseUrl}/sxcl/v1/service-providers/${serviceProviderId}/performance`,
  };
}

export {
  LOCATIONS_STEPPER_ID,
  deriveServiceProviderScope,
  buildTabNavigationPath,
  resolveSystemSettingsTabViews,
  hasVisibleLocationSystemSettingsTabs,
  isModuleTabPurchased,
  getApiEndPoints,
};
